import { Skeleton } from '@diana/core';

export const ConfigureDrawerContentLoader = () => {
  return <Skeleton count={6} />;
};
